export const adobeTargetDataLayer = (window as any).adobeDataLayer ?? [];
